export interface ReportJobPayloadContext {
  jobKey: string;
  /** Mosaic platform id, e.g. `"jobsearch"`. */
  hostId: string;
  /** Surface page id, e.g. `"serp"` / `"homepage"` / `"viewjob"`. */
  pageId: string;
  ctk: string;
  isLoggedIn: boolean;
  isConfirmed: boolean;
  country: string;
  language: string;
  isMobile: boolean;
  userAgent: string;
  /** Surface tracking key (mobtk / mobvjtk). */
  logEntryTK: string;
}

/**
 * Builds the report-content JSON body for a `report_job` content report. Shared by
 * RN ViewJob (`viewjobOneGraphModel`) and `useReportJobSubmit` so the payload shape
 * lives in one place.
 */
export function buildReportJobPayload(
  context: ReportJobPayloadContext,
  reason: string,
  moreInfo: string,
): string {
  return JSON.stringify({
    reportFormResult: {
      reportResults: [{ type: reason, isChecked: true }],
      textFeedback: moreInfo,
    },
    contentReportData: {
      contentReportType: "report_job",
      hostId: context.hostId,
      pageId: context.pageId,
      contentId: context.jobKey,
      ctk: context.ctk,
      isLoggedIn: context.isLoggedIn,
      isConfirmed: context.isConfirmed,
      country: context.country,
      language: context.language,
      isMobile: context.isMobile,
      userAgent: context.userAgent,
      logEntryTK: context.logEntryTK,
    },
  });
}
